import {
  SET_NOTIFICATIONS, UNSET_NOTIFICATIONS,
  REMOVE_NOTIFICATION,
} from '@/vuex/modules/notifications/types/mutations';

import {
  DEFINE_NOTIFICATIONS, CLEAR_NOTIFICATIONS,
  MARK_NOTIFICATION_READ,
} from '@/vuex/modules/notifications/types/actions';


export default {
  state: {
    notifications: [],
  },
  getters: {
    notifications: state => state.notifications,
  },
  mutations: {
    [SET_NOTIFICATIONS](state, notifications) {
      state.notifications = notifications || [];
      localStorage.notifications = JSON.stringify(state.notifications);
    },
    [UNSET_NOTIFICATIONS](state) {
      state.notifications = [];
      localStorage.removeItem('notifications');
    },
    [REMOVE_NOTIFICATION](state, payload) {
      const notificationID = payload.id;
      const notifications = state.notifications;
      state.notifications = notifications.filter(el => el.id !== notificationID);
      localStorage.notifications = JSON.stringify(state.notifications);
    },
  },
  actions: {
    [DEFINE_NOTIFICATIONS](context, payload) {
      context.commit(SET_NOTIFICATIONS, payload.notifications);
    },
    [CLEAR_NOTIFICATIONS](context) {
      context.commit(UNSET_NOTIFICATIONS);
    },
    [MARK_NOTIFICATION_READ](context, payload) {
      context.commit(REMOVE_NOTIFICATION, { id: payload.id });
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/notifications/index.js